import {Item} from "../models/Item";

export class AbstractMainPlugin {
  public item:Item;

  public prepareItemConfig(config?){}
  public static getUsedComponents() { return []; }
  public static getBeforeItemComponents() { return []; }

  static registerOnItem(item:Item) {
    return new this(item);
  }

  static getComponentForLocation(name:any, item?: Item){
    return null;
  }

  constructor(item:Item) {
    this.item = item;
    this.item.registeredPlugins.push(this);
  }

  setItemVisibilityComponent(v: boolean) {
    this.item.setVisibilityComponent(this.constructor.name, v);
  }
}

